import { useMemo } from "react";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { GenerateSaidaProdutosColumns } from "./columns/saida_produtos";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { useSaidaProdutosListaViewModel } from "../../viewModels/saidaProdutos_lista_view_model";
import { SaidaProduto } from "../../../domain/models/saida_produtos_lista";
import { SaidaProdutoModal } from "./components/saidaProduto_modal";
import { SaidaProdutoMultiModal } from "./components/entradaProduto_multi_modal";
import { ReportModal } from "./components/report_modal";

import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ProdutoServicoDrawer } from "../../../../../common/components/drawers_api/drawers/produto_servico_drawer";

export const SaidaProdutosLista = () => {
  const viewModel = useSaidaProdutosListaViewModel();
  const SaidaProdutosListaColumns = useMemo(() => {
    return GenerateSaidaProdutosColumns({
      onActionEditar: viewModel.handleCadastroSaidaOpenState,
      onActionDeletar: viewModel.handleDeleteModalOpenState,
    });
  }, [viewModel.handleCadastroSaidaOpenState, viewModel.handleDeleteModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={() => viewModel.handleReportModalOpenState(true)}
                  buttonColor="yellow">
                  Relatórios
                </PrimaryButton>
              </div>
              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroSaidaOpenState(null, true)}>
                  Incluir Item
                </PrimaryButton>
              </div>
              <div className="w-[220px] ">
                <PrimaryButton
                  buttonColor="secondary"
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroSaidaMultiOpenState(true)}>
                  Incluir Múltiplas Saídas
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Estoque
            </Link>
            <Typography className="text-primary-green">
              Saída de Produtos
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Saída de Produtos</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleFuncionarioChange={viewModel.handleFuncionarioChange}
            FuncionarioPesquisa={viewModel.filters.FuncionarioPesquisa}
            centroDeCustoSaida={viewModel.filters.centroDeCustoSaida}
            centroDeCustoDestino={viewModel.filters.centroDeCustoDestino}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            handleCentroDeCustoDestino={viewModel.handleCentroDeCustoDestinoChange}
            handleCentroDeCustoSaida={viewModel.handleCentroDeCustoSaidaChange}
            dataSaidaAte={viewModel.filters.dataSaidaAte}
            dataSaidaDe={viewModel.filters.dataSaidaDe}
            handleDataEntradaRangeChange={viewModel.handleDataSaidaRangeChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            handleProdutorChange={viewModel.handleProdutorChange}
            ProdutorPesquisa={viewModel.filters.ProdutoPesquisa}


          />
          <StyledDataGrid
            tableName="Saida_Produtos_lista"
            disableColumnMenu={false}
            getRowId={(row: SaidaProduto) => row.IdSaidaProduto}
            columns={SaidaProdutosListaColumns}
            loading={viewModel.loading}
            rows={viewModel.saidaProdutoLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ["IdEntradaProduto"],
            }}
            autoHeight={true}
            textSize="medio"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      <ProdutoServicoDrawer
        saving={viewModel.saving}
        state={viewModel.produtoServicoDrawerState}
      />

      <SaidaProdutoModal
        loading={viewModel.loading}
        onClose={() => viewModel.setSaidaModal(false)}
        onSubmit={viewModel.handleSaidaProdutoSubmit}
        open={viewModel.saidaModal}
        saving={viewModel.saving}
        selectedSaidaProduto={viewModel.selectedSaidaProduto}
        dropdownProdutosServicos={viewModel.produtosServicosDropDown ?? []}
        centroCustoLista={viewModel.centroDeCustoLista}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

      <SaidaProdutoMultiModal
        loading={viewModel.loading}
        onClose={() => viewModel.setSaidaMultiModal(false)}
        onSubmit={viewModel.handleSaidaProdutoMultiSubmit}
        onUpdate={viewModel.handleUpdateMutiTodos}
        open={viewModel.saidaMultiModal}
        saving={viewModel.saving}
        selectedSaidaProduto={viewModel.selectedSaidaProduto}
        centroCustoLista={viewModel.centroDeCustoLista}
        handleProdutosServicosQueryChange={viewModel.handleProdutosServicosQueryChange}
        produtosServicosDropDown={viewModel.produtosServicosDropDown ?? []}
        selectedProdutosServicosQuery={viewModel.selectedProdutosServicosQuery}
        saidaProduto={viewModel.produtoIdSessaoLista}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
        OnActionCentroCustoChange={viewModel.handleCentroCustoChange}
        OnActionCentroCustoDestinoChange={viewModel.handleCentroCustoDestinoChange}
        FuncionariosLista={viewModel.funcionariosLista ?? []}
        OnActionQuantidadeChange={viewModel.handleQuantidadeChange}
        OnActionFuncionarioChange={viewModel.handleFuncionarioMChange}
        OnActionValorChange={viewModel.handleValorChange}
        OnActionDataChange={viewModel.handleDataChange}
        onNewProdutoServico={viewModel.handleNewProdutoServico}
        OnActionLocalAplicacaoChange={viewModel.handleLocalAplicacaoChange}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <DeleteDialog
        open={viewModel.deleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirma} />

      <ReportModal
        saving={viewModel.saving}
        selectedCentroCustoQuery={viewModel.selectedCentroCustoQuery}
        centroCustoDropDown={viewModel.centroDeCustoLista}
        handleCentroCustoQueryChange={viewModel.handleCentroCustoQueryChange}
        open={viewModel.openReportModal}
        reactHookForm={viewModel.hookForm}
        onSubmit={viewModel.handleSubmitReport}
        onClose={() => viewModel.handleReportModalOpenState(false)}
        handleCentroCustoDestinoQueryChange={viewModel.handleCentroCustoDestinoQueryChange}
        selectedCentroCustoDestinoQuery={viewModel.selectedCentroCustoDestinoQuery}
      />

    </>
  )
};
